import type { ComponentType } from 'react';
import type { RouteObject } from 'react-router';
import { PermissionGate } from '@saas/ui';
import { STORAGE_ADMIN } from './nav.js';

/** apps/web が集約する。ルート単位で遅延ロード（03 第 I 部 §2） */
type PageModule = { default: ComponentType };

function page(load: () => Promise<PageModule>): RouteObject['lazy'] {
  return async () => {
    const m = await load();
    return { Component: m.default };
  };
}

function guarded(load: () => Promise<PageModule>, anyOf: string[]): RouteObject['lazy'] {
  return async () => {
    const m = await load();
    const Page = m.default;
    const Guarded = () => (
      <PermissionGate anyOf={anyOf}>
        <Page />
      </PermissionGate>
    );
    return { Component: Guarded };
  };
}

/** ログイン後（シェルの中・`ModuleGate module="storage"` の下） */
export const storageRoutes: RouteObject[] = [
  { path: '/storage', lazy: page(() => import('./pages/StorageDrivePage.js')) },
  { path: '/storage/shared', lazy: page(() => import('./pages/StorageDrivePage.js')) },
  { path: '/storage/shared-with-me', lazy: page(() => import('./pages/StorageDrivePage.js')) },
  { path: '/storage/recent', lazy: page(() => import('./pages/StorageDrivePage.js')) },
  { path: '/storage/starred', lazy: page(() => import('./pages/StorageDrivePage.js')) },
  { path: '/storage/search', lazy: page(() => import('./pages/StorageDrivePage.js')) },
  { path: '/storage/folders/:folderId', lazy: page(() => import('./pages/StorageDrivePage.js')) },
  { path: '/storage/files/:fileId', lazy: page(() => import('./pages/StorageFilePage.js')) },
  { path: '/storage/trash', lazy: page(() => import('./pages/StorageTrashPage.js')) },
  { path: '/storage/admin', lazy: guarded(() => import('./pages/StorageAdminPage.js'), [STORAGE_ADMIN]) },
];

/**
 * ログイン不要の公開ルート（社外へ渡す共有リンク。URL は `${APP_URL}/s/<token>`）。
 * `apps/web/src/app/router.tsx` では、safety の回答ページ（`safetyPublicRoutes`）と同じ場所 —
 * `PublicOnly`（ログイン済みなら / へ戻す）でも `RequireAuth` でもない側 — に置く。
 * シェルも `useAuth` も使わないので、社員がログインしたままでも、まったくの社外の人でも同じように開ける。
 */
export const storagePublicRoutes: RouteObject[] = [{ path: '/s/:token', lazy: page(() => import('./pages/PublicSharePage.js')) }];
